import React from 'react';
import { useNavigate } from 'react-router-dom';

// Footer Component with Navigation
function Footer() {
  const navigate = useNavigate();

  const handleNavigation = (section) => {
    // Navigate to dashboard and scroll to specific section
    navigate('/', { state: { scrollTo: section } });
  };

  return (
    <div class="section padding-top-bottom-small footer">
      <div class="parallax-footer"></div>
      <div>
        <div class="footer-flex">
          <div class="left-side">
            <div className="footer-logo-full">
              <div className="logo-footer"></div>
              <br />
              <br />
              <div class="social-footer">
                <ul class="list-social">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <a className="insta" href="https://www.instagram.com/aquaman.openwater?igsh=MTR4dG5xZDczNDl0eQ%3D%3D&utm_source=qr" target='_blank'  />
                    <a className="facebook" href="https://www.facebook.com/aquaman.openwaterswimming?mibextid=LQQJ4d" target='_blank' />
                    <a className="mail" href="mailto:communication@aquaman.co" />
                  </div>
                </ul>
              </div>
            </div>
          </div>

          <div class="footer-column">
            <p class="footer-column-title">RACES</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('races')}>Open Water Swimming</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('races')}>Obstacle Course</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('races')}>Aquathlon</p>
          </div>
          <div class="footer-column">
            <p class="footer-column-title">WHY AQUAMAN</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('why')}>About Us</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('why')}>Careers</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('why')}>Volunteer</p>
          </div>
          <div class="footer-column">
            <p class="footer-column-title">Passport</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('passport')}>Become A Coach</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('passport')}>Train On-ground</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('passport')}>Online Race Training</p>
          </div>
          <div class="footer-column">
            <p class="footer-column-title">SHOP</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('store')}>Race Gear</p>
            <p class="footer-column-items" style={{cursor: 'pointer'}} onClick={() => handleNavigation('store')}>Aquaman Merchandise</p>
          </div>
        </div>
        <div class="social-footer-mobiles">
          <ul class="list-social">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "80vw",
                margin: "24px auto 8px auto",
              }}
            >
              <div className="insta" alt="" />
              <div className="facebook" alt="" />
              <div className="youtube" alt="" />
              <div className="tiktok" alt="" />
              <div className="mail" alt="" />
            </div>
          </ul>
        </div>
        <div class="footer-copy-text">
          <p>
            Terms and Conditions / Website Terms of Use / Privacy Policy /
            Cookie Preferences © 2024 Aquaman.openwater
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;









